class GroupByResults extends HTMLElement {
    constructor() {
        super();
        this.isFirstTimeLoad = true;
        this.productsContainer = this.querySelector('[data-gb-products]');
        this.paginationContainer = this.querySelector('[data-gb-pagination]');
        this.facetsContainer = this.querySelector('[data-gb-facets]');
        this.resultsSummaryContainer = this.querySelector('[data-gb-results-summary]');
        this.terms = this.getAttribute('data-gb-terms');
        this.dynamicFilters = [];
        this.sortBy = this.getAttribute('data-gb-sort-by');
        this.currentPage = parseInt(this.paginationContainer.getAttribute('data-gb-page')) ?? 1;
        this.perPage = parseInt(this.paginationContainer.getAttribute('data-gb-per-page')) ?? 10;
        this.totalPages = 0;
        this.baseUrl = '/search';

        this.init();
    }

    bindEvents() {
        this.addEventListener('change', (event) => {
            if (event.target.matches('.facet-filters__sort-option input[type="radio"]')) {
                this.refreshResults();
            }
        });
        this.addEventListener('click', (event) => {
            if (event.target.closest('[data-gb-filter-price]')) {
                this.currentPage = 1;
                this.refreshResults();
                this.closeFiltersAndScroll()
            }
        });
        this.addEventListener('click',  (event) => {
            if (event.target.matches('[data-gb-pagination-item]')) {
                this.currentPage = parseInt(event.target.getAttribute('data-gb-pagination-item'));
                this.refreshResults();
                this.scrollToTop();
            }
        })
        this.addEventListener('change',  (event) => {
            if (event.target.matches('.facet-filters__label-checkbox')) {
                this.currentPage = 1;
                this.refreshResults();
                this.closeFiltersAndScroll();
            }
        });
        this.addEventListener('click', (event) => {
            if (event.target.closest('.button-show-more')) {
                const button = event.target.closest('.button-show-more');
                const filterName = button.getAttribute('data-show-more');
                const hiddenOptions = document.querySelectorAll(`[data-filter-option="${filterName}"].hidden`);
                const showMoreLabel = button.querySelector('.label-show-more');
                const showLessLabel = button.querySelector('.label-show-less');

                if (hiddenOptions.length > 0) {
                    hiddenOptions.forEach(option => option.classList.remove('hidden'));
                    showMoreLabel.classList.add('hidden');
                    showLessLabel.classList.remove('hidden');
                } else {
                    document.querySelectorAll(`[data-filter-option="${filterName}"]`).forEach((option, index) => {
                        if (index >= 11) option.classList.add('hidden');
                    });
                    showMoreLabel.classList.remove('hidden');
                    showLessLabel.classList.add('hidden');
                }
            }
        });
    }

    scrollToTop() {
        setTimeout(() => {
            const target = document.querySelector('.gradient');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);
    }

    closeFiltersAndScroll() {
        setTimeout(() => {
            const filterWrapper = document.querySelector('.facets-vertical__sort-filter-wrapper.show');
            const scrollToFiltersTop = document.getElementById('verticalTitle');

            if (filterWrapper) {
                filterWrapper.classList.remove('show');
            }

            if (scrollToFiltersTop) {
                scrollToFiltersTop.scrollIntoView({ behavior: 'smooth', block: 'start' });
                const elementPosition = scrollToFiltersTop.getBoundingClientRect().top;
                window.scrollBy({ top: elementPosition - 30, behavior: 'smooth' });
            }
        }, 500);
    }


    async refreshResults() {
        const data = await this.fetchData();

        const resultsCount = data.totalRecordCount;

        this.resultsSummaryContainer.innerHTML = this.prepareResultsSummaryHtml(resultsCount);

        document.title = `Search: ${resultsCount} results for “${this.terms}” - ${window.location.hostname}`;

        if (resultsCount === 0) {
            this.productsContainer.innerHTML = '';
            this.renderNoProductResults();
            return;
        }

        this.totalPages = this.calculateTotalPages(data);

        await this.renderProductCardsHtml(data);

        this.renderFacets(data);

        const paginationElement = this.buildPaginationElement();

        this.paginationContainer.replaceChildren(paginationElement);
    }

    async init() {

        try { initTracking(); } catch (e) { console.warn('[GroupBy] initTracking failed:', e); }

        try {
            const data = await this.fetchData();
            const filterLabel = document.querySelector('.active-facets-vertical-filter.sort-filter-forms');

            if (data.redirect) {
                window.location.href = data.redirect;
                return null;
            }

            filterLabel.classList.remove('hidden')

            this.isFirstTimeLoad = false;

            const resultsCount = data.totalRecordCount;

            if (resultsCount === 0) {
                this.renderNoResults();
                return;
            }

            this.resultsSummaryContainer.innerHTML += this.prepareResultsSummaryHtml(resultsCount);

            document.title = `Search: ${resultsCount} results for “${this.terms}” - ${window.location.hostname}`;

            this.totalPages = this.calculateTotalPages(data);

            await this.renderProductCardsHtml(data);

            this.renderFacets(data);
            const paginationElement = this.buildPaginationElement();

            this.paginationContainer.appendChild(paginationElement);

            this.bindEvents();
        } catch (error) {
            this.renderError(error);
        }
    }



    calculateTotalPages(data) {
        return Math.ceil(data.totalRecordCount / this.perPage);
    }

    buildPaginationElement() {
        const paginationContainer = document.createElement("div");
        paginationContainer.classList.add("pagination__list", "list-unstyled");
        paginationContainer.setAttribute("role", "list");

        paginationContainer.innerHTML += this.createPreviousButton();

        const paginationItemsWrapper = document.createElement("div");
        paginationItemsWrapper.classList.add("pagination__items-wrapper");

        if (this.currentPage > 3) {
            paginationItemsWrapper.innerHTML += this.createPageItem(1);
            if (this.currentPage > 4) paginationItemsWrapper.innerHTML += this.createEllipsis();
        }

        for (let i = Math.max(1, this.currentPage - 2); i <= Math.min(this.totalPages, this.currentPage + 2); i++) {
            if (i === this.currentPage) {
                paginationItemsWrapper.innerHTML += `
                    <div class="pagination__page-number" role="listitem">
                        <span role="link" aria-disabled="true" class="pagination__item pagination__item--current" aria-current="page" aria-label="Page ${i}" data-gb-pagination-item="${i}">${i}</span>
                    </div>
                `;
            } else {
                paginationItemsWrapper.innerHTML += this.createPageItem(i);
            }
        }

        if (this.currentPage < this.totalPages - 2) {
            if (this.currentPage < this.totalPages - 3) paginationItemsWrapper.innerHTML += this.createEllipsis();
            paginationItemsWrapper.innerHTML += this.createPageItem(this.totalPages);
        }

        paginationContainer.appendChild(paginationItemsWrapper);

        paginationContainer.innerHTML += this.createNextButton();

        return paginationContainer;
    }

    createPreviousButton() {
        if (this.currentPage === 1) {
            return `<div class="pagination__list-prev" role="listitem"></div>`;
        } else {
            return `
            <div class="pagination__list-prev" role="listitem">
                <span href="${this.baseUrl}?page=${this.currentPage - 1}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Prev">
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" data-gb-pagination-item="${this.currentPage - 1}">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                    <span class="pagination__item--prev-text" data-gb-pagination-item="${this.currentPage - 1}">Prev</span>
                </span>
            </div>
        `;
        }
    }

    createNextButton() {
        if (this.currentPage === this.totalPages) {
            return `<div class="pagination__list-next" role="listitem"></div>`;
        } else {
            return `
            <div class="pagination__list-next" role="listitem">
                <span href="${this.baseUrl}?page=${this.currentPage + 1}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Next">
                    <span class="pagination__item--next-text" data-gb-pagination-item="${this.currentPage + 1}">Next</span>
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" data-gb-pagination-item="${this.currentPage + 1}">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                </span>
            </div>
        `;
        }
    }

    createPageItem(page) {
        return `<div class="pagination__page-number" role="listitem">
            <span href="${this.baseUrl}?page=${page}" class="pagination__item link" aria-label="Page ${page}" data-gb-pagination-item="${page}">${page}</span>
        </div>`;
    }

    createEllipsis() {
        return `<div class="pagination__page-number" role="listitem">
            <span class="pagination__item">…</span>
        </div>`;
    }

    async renderProductCardsHtml(data) {
        const firstBatch = data.records.slice(0, 10);
        const remainingBatch = data.records.slice(10);

        const firstHtmlPromise = this.loadCards(firstBatch);
        const secondHtmlPromise = this.loadCards(remainingBatch);

        this.productsContainer.innerHTML = await firstHtmlPromise;
        this.productsContainer.innerHTML += await secondHtmlPromise;
    }

    extractProductHandle(record) {
        const handleAttr = record?.allMeta?.attributes?.handle;
        if (handleAttr == null) return null;
        if (typeof handleAttr === 'string' && handleAttr.trim()) return handleAttr.trim();
        const text = handleAttr.text;
        if (Array.isArray(text) && text[0]) return String(text[0]).trim();
        if (typeof text === 'string' && text.trim()) return text.trim();
        return null;
    }

    async loadCards(records) {
        const requests = records.map(async (record) => {
            const handle = this.extractProductHandle(record);
            if (!handle) {
                console.warn('[GroupByResults] Skipping record without product handle', record?.id ?? '(no id)');
                return '';
            }
            let url = `/products/${handle}?view=card`;

            const matchingVariant = this.findMatchingVariantSku(record);

            if (matchingVariant) {
                url += `&variant=${matchingVariant.id}`;
            }

            const responseText = await fetch(url).then((response) => response.text());
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const productCard = html.querySelector('.collection-banner_recently-viewed');

            if (productCard && matchingVariant) {
                this.updateProductCardLinks(productCard, matchingVariant.id);
            }

            return productCard?.outerHTML || '';
        });

        const htmlArray = await Promise.all(requests);
        return htmlArray.join('');

    }

    updateProductCardLinks(productCard, variantId) {
        const links = productCard.querySelectorAll('a[href*="/products/"]');

        links.forEach(link => {
            const href = link.getAttribute('href');
            if (href) {
                let newHref = href.split('?')[0];

                const separator = newHref.includes('?') ? '&' : '?';
                newHref += `${separator}variant=${variantId}`;

                link.setAttribute('href', newHref);
            }
        });
    }

    findMatchingVariantSku(record) {
        const normalizedQuery = this.terms
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
            .replace(/[+\-_]/g, '');

        if (record.allMeta?.variants && Array.isArray(record.allMeta.variants)) {
            for (const variant of record.allMeta.variants) {
                const variantSku = variant.attributes?.sku?.text?.[0];

                if (variantSku) {
                    const normalizedSku = String(variantSku)
                        .trim()
                        .toLowerCase()
                        .replace(/\s+/g, '')
                        .replace(/[+\-_]/g, '');

                    if (normalizedSku === normalizedQuery) {
                        return {
                            id: variant.id,
                            sku: variantSku
                        };
                    }
                }
            }
        }

        return null;
    }

    renderNoResults() {
        this.paginationContainer.innerHTML = `No results found for “${ this.terms }”. Check the spelling or use a different word or phrase.`;
    }

    renderNoProductResults() {
        this.paginationContainer.innerHTML = `No results found for the selected filters. Please adjust your filters and try again.`;
    }

    renderError(error) {
        console.log(error);
        this.productsContainer.innerHTML += 'Something went wrong. Please try again';
    }

    renderFacets(data) {
        this.facetsContainer.innerHTML = '';
        this.facetsContainer.innerHTML += this.createSortItem();
        this.facetsContainer.innerHTML += this.createFilterItem(data);
        setTimeout(() => {
            this.restoreSelectedFilters()
            const minInput = this.querySelector('#minPrice');
            const maxInput = this.querySelector('#maxPrice');

            if (minInput) minInput.value = this.minPrice;
            if (maxInput) maxInput.value = this.maxPrice;
        }, 0);

    }

    restoreSelectedFilters() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"][name^="filter."]');

        checkboxes.forEach(checkbox => {
            const [, ...navigationParts] = checkbox.name.split('.');
            const navigationName = navigationParts.join('.');

            checkbox.checked = this.dynamicFilters.some(
                filter => filter.navigationName === navigationName && filter.value === checkbox.value
            );
        });
    }

    createSortItem() {
        const sortOptions = [
            { id: 'Relevance', value: 'relevance', text: 'Relevance' },
            { id: 'PriceLowToHigh', value: 'price-ascending', text: 'Lowest Price' },
            { id: 'PriceHighToLow', value: 'price-descending', text: 'Highest Price' }
        ];

        const sortItemsHtml = sortOptions.map(option => `
        <li class="list-menu__item facets__item facet-filters__sort-option">
            <label class="facet-filters__label facets__label facet-checkbox" for="${option.id}">
                <label class="hidden" for="${option.id}">${option.text}</label>
                <input id="${option.id}" 
                    class="facet-filters__sort-input facet-filters__sort" 
                    data-facet-filters-label="" 
                    type="radio" 
                    name="sort_by" 
                    value="${option.value}" ${this.sortBy === option.value ? 'checked' : ''}>
                <div class="facet-checkbox-wrapper">
                    <span class="facet-checkbox__text" aria-hidden="true">
                        ${option.text}
                    </span>
                    <span class="facet-filters__label-checkbox"></span>
                </div>
            </label>
        </li>
    `).join('');

        return `
            <div class="facets facets-vertical-sort no-js-hidden">
                            <div class="facets-vertical-form">
                                <div class="facet-filters sorting caption">
                                    <div class="facet-filters__field">
                                        <h2 class="facets__heading facets__subheading--vertical">
                                            <label for="SortByOptionsList">Sort by:</label>
                                        </h2>
                                        <ul id="SortByOptionsList" class="sorting facets__list--vertical list-unstyled no-js-hidden">
                                            ${sortItemsHtml}
                                        </ul>
                                    </div>
                                </div>
                            </div>
            </div>
    `;
    }

    prepareDynamicFilters(availableNavigation) {
        let html = '';

        for (const navigation of availableNavigation) {
            const skip = ['price', 'attributes.widget', 'attributes.badge'];
            if (skip.includes(navigation.name)) {
                continue;
            }

            let optionsHtml = '';
            const maxVisible = 11;
            let hasHiddenOptions = false;
            let totalFilters = navigation.refinements.length;

            navigation.refinements.forEach((refinement, index) => {
                const isHidden = index >= maxVisible ? 'hidden' : '';
                if (index >= maxVisible) hasHiddenOptions = true;

                const sanitizedValue = refinement.value.includes('"') ? refinement.value.replace(/"/g, '&quot;') : refinement.value;

                optionsHtml += `
              <li class="list-menu__item facets__item ${isHidden}" data-filter-option="${navigation.name}">
                <label for="filter.${navigation.name}.${sanitizedValue}" class="facets__label facet-checkbox facet-filters__label">
                  <input type="checkbox" name="filter.${navigation.name}" aria-label="${sanitizedValue}" value="${sanitizedValue}" class="facet-filters__label-checkbox focus-inset" id="filter.${navigation.name}.${sanitizedValue}">
                  <span class="facet-checkbox__text" aria-hidden="true">${refinement.value}</span>
                </label>
              </li>
            `;
            });

            let showMoreHtml = '';
            if (hasHiddenOptions) {
                let hiddenCount = totalFilters - maxVisible;
                showMoreHtml = `
              <div class="facets__show-more-separator"></div>
              <show-more-button>
                <button
                  class="button-show-more link underlined-link no-js-hidden"
                  data-show-more="${navigation.name}"
                  data-hidden-count="${hiddenCount}"
                  type="button"
                >
                  <span class="label-show-more label-text">
                    <span aria-hidden="true"></span> More (${hiddenCount})
                  </span>
                  <span class="label-show-less label-text hidden">
                    <span aria-hidden="true"></span> Less
                  </span>
                </button>
              </show-more-button>
            `;
            }

            html += `
            <div class="facet-filters filter caption">
                <div class="facets__disclosure-vertical">
                  <div class="facets__summary caption-large focus-offset" aria-label="Filter by ${navigation.displayName}">
                    <div>
                      <h2 class="facets__summary-label facets__heading facets__subheading--vertical">
                        Filter By ${navigation.displayName}
                      </h2></div>
                  </div>
                  <div id="Facet-${navigation.name}" class="parent-display facets__display-vertical">
                    <fieldset class="facets-wrap parent-wrap facets-wrap-vertical">
                      <legend class="visually-hidden">${navigation.displayName}</legend>
                      <ul class="facets-layout-list facets__list--vertical list-unstyled no-js-hidden" role="list">
                          ${optionsHtml}
                      </ul>
                      ${showMoreHtml}
                    </fieldset>
                  </div>
                </div>
            </div>
        `;
        }

        return html;
    }

    createFilterItem(data) {
        const dynamicFacetsHtml = this.prepareDynamicFilters(data.availableNavigation);

        return `
            <div class="facets">
                <div class="facets__form-vertical">
                    <div id="FacetsWrapperDesktop">
                    <div class="facet-filters filter caption">
                         <div class="facets__summary caption-large focus-offset" aria-label="Filter by Shirt Sleeve">
                            <div>
                              <h2 class="facets__summary-label facets__heading facets__subheading--vertical">
                                Filter by Price
                              </h2></div>
                          </div>
                          <div class="parent-display facets__display-vertical">
                            <fieldset class="facets-wrap parent-wrap  facets-wrap-vertical">
                                <div class="input-group">
                                    <div class="input-wrapper">
                                        <label for="minPrice">Minimum</label> 
                                        <div class="currency-input-wrapper">
                                            <span class="currency-symbol">$</span> 
                                            <input id="minPrice" type="number" min="0" step="1" class="currency-input">
                                        </div>
                                    </div> 
                                    <div class="input-wrapper">
                                        <label for="maxPrice">Maximum</label> 
                                        <div class="currency-input-wrapper">
                                            <span class="currency-symbol">$</span> 
                                            <input id="maxPrice" type="number" min="0" step="1" class="currency-input">
                                        </div>
                                    </div>
                                </div> 
                                <button class="button apply-button" data-gb-filter-price>Apply</button>
                            </fieldset>
                          </div>
                      </div>

                      ${dynamicFacetsHtml}
                  </div>
              </div>
          </div>
        `;
    }

    prepareResultsSummaryHtml(resultsCount) {
        return `
          <div class="facets-vertical-form" id="FacetSortForm">
            <div class="product-count-vertical" role="status">
              <h2 class="product-count__text text-body">
                <span id="ProductCountDesktop">Showing <span class="results-number"> ${resultsCount}</span> results for “${this.terms}”</span>
              </h2>
            </div>
          </div>
        `;
    }

    // --- Filters ---

    collectSelectedFilters() {
        const selectedFilters = [];

        if (this.isFirstTimeLoad) {
            return selectedFilters;
        }

        const priceFilter = this.getPriceFilter();
        if (priceFilter) {
            selectedFilters.push(priceFilter);
        }

        this.getDynamicFilters();
        selectedFilters.push(...this.dynamicFilters);

        return selectedFilters;
    }

    getPriceFilter() {
        const minPriceInput = this.querySelector('#minPrice');
        const maxPriceInput = this.querySelector('#maxPrice');

        const minPriceValue = minPriceInput?.value;
        const maxPriceValue = maxPriceInput?.value;

        this.minPrice = minPriceValue !== '' ? parseFloat(minPriceValue) : null;
        this.maxPrice = maxPriceValue !== '' ? parseFloat(maxPriceValue) : null;

        if (this.minPrice === null && this.maxPrice === null) {
            return null;
        }

        return {
            "displayName": "refinement",
            "high": this.maxPrice ?? 9999,
            "low": this.minPrice ?? 0,
            "navigationName": "price",
            "or": true,
            "type": "Range",
        };
    }

    getDynamicFilters() {
        const checkboxes = document.querySelectorAll('input[type="checkbox"][name^="filter."]');

        checkboxes.forEach(checkbox => {
            const [, ...navigationParts] = checkbox.name.split('.');
            const navigationName = navigationParts.join('.');

            const existingIndex = this.dynamicFilters.findIndex(filter => filter.navigationName === navigationName && filter.value === checkbox.value);

            if (checkbox.checked && existingIndex === -1) {
                this.dynamicFilters.push({
                    displayName: "refinement",
                    navigationName: navigationName,
                    or: true,
                    type: "Value",
                    value: checkbox.value
                });
            } else if (!checkbox.checked && existingIndex !== -1) {
                this.dynamicFilters.splice(existingIndex, 1);
            }
        });

        return this.dynamicFilters;
    }

    collectSelectedSorts() {
        let sorts = [];

        if (! this.isFirstTimeLoad) {
            this.sortBy = this.querySelector('[name="sort_by"]:checked').value;
        }

        if (this.sortBy !== 'relevance') {
            const valueArr = this.sortBy.split('-');
            sorts = [
                {
                    "field": valueArr[0],
                    "order": valueArr[1],
                }
            ]
        }

        return sorts;
    }

    async fetchData() {

        const url = "https://search.shp.groupbycloud.com/api/search";

        const payload = {
            "query": this.terms,
            "collection": "Production",
            "area": "Production",
            "pageSize": this.perPage,
            "sorts": this.collectSelectedSorts(),
            "fields": ["*"],
            "dynamicFacet": false,
            "preFilter": "availability:ANY(\"IN_STOCK\")",
            "skip": (this.currentPage - 1) * this.perPage,
            "refinements": this.collectSelectedFilters(),
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": window.groupbyKey,
                    "Content-Type": "application/json",
                    "Skip-Caching": "true",
                    "X-Groupby-Customer-Id": window.groupbyCustomerId
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            const hasGbTracker = typeof gbTracker !== 'undefined' && gbTracker;
            const visitorId = hasGbTracker
                ? gbTracker.getVisitorId()
                : (document.cookie.split('; ').find(c => c.startsWith('gbi_visitorId='))?.split('=')[1] || '');
            const sessionId = hasGbTracker
                ? gbTracker.getSessionId()
                : (sessionStorage.getItem('session_id') || '');

            if (hasGbTracker && data.id) {
                fetch("https://events.shp.groupbycloud.com/wisdom/v2/pixel", {
                    method: "POST",
                    mode: "no-cors",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Groupby-Customer-Id": window.groupbyCustomerId
                    },
                    body: JSON.stringify({
                        clientVersion: { raw: "5.4.0" },
                        customer: {
                            id: window.groupbyCustomerId,
                            area: "Production"
                        },
                        eventType: "autoSearch",
                        search: {
                            id: data.id,
                            origin: {
                                sayt: false,
                                dym: false,
                                search: true,
                                recommendations: false,
                                autosearch: false,
                                navigation: true,
                                collectionSwitcher:false
                            }
                        },
                        visit: {
                            customerData: {
                                ...(window.groupbyLoginId ? { loginId: window.groupbyLoginId } : {}),
                                sessionId: sessionId,
                                visitorId: visitorId
                            },
                            generated: {
                                uri: window.location.href,
                                timezoneOffset: new Date().getTimezoneOffset(),
                                localTime: new Date().toISOString()
                            }
                        }
                    })
                });
            }

            return data;
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }
}

customElements.define('group-by-results', GroupByResults);